// @ts-check

import { withinDateRange } from '../client/utils/withinDateRange';

/* host names */
export const tkCanonicalHost = 'https://www.theknot.com';
export const tkHost = 'https://www.theknot.com';
export const tkNext =
	'https://tk-marketplace-fe-nextjs-prod.k8s.localsolutions.theknot.com';

/* api keys */
export const analyticsWriteKey = '0KXGZo0hporpqj3UE8vz6GNa1U0GIs45';
export const branchKey = 'key_live_fgBjA4VZ745PUUGEzvdKZppfEybg1veM';

/* endpoints */
export const mediaApiUrl = 'https://media-api.xogrp.com/images/';
export const videoMediaApiUrl = 'https://media-api.xogrp.com/videos/';
export const geoApiUrl = 'https://geo-api-internal.xogrp.com';
export const noServicesUrl = 'https://no-services.theknot.com';
export const weddingsRootUrl = 'https://api.weddings.xogrp.com';
export const weddingsRootUrlK8 = 'http://wedding-api-prod.coreservices';
/* from George M. going forward there is no internal K8s url */
export const apiBaseUrlK8 =
	'https://svc-internal.theknotww.com/marketplace-search-api';
export const graphqlApiUrlK8 = `${apiBaseUrlK8}/graphql`;
export const serviceHealthApiUrlK8 = `${apiBaseUrlK8}/service-health`;
export const graphqlApiUrl =
	'https://prod-marketplace-api.localsolutions.theknot.com/graphql';
export const unifiedReviewsApiUrl =
	'https://svc.theknotww.com/reviews-api/graphql';
export const reviewAiSummaryUrl =
	'https://review-summaries.dataops.nuptic.com/predict';
export const googleReviewsUrl =
	'https://svc-internal.theknotww.com/third-party-places/graphql';
export const taxonomyApi = 'https://api.dataintel.xogrp.com/taxonomy/knot';
export const experimentAPI =
	'https://api.experimentation.xogrp.com/experiments';
export const multiExperimentsAPI =
	'https://api.experimentation.xogrp.com/multi/experiments';
export const identityApi =
	'https://prod-identity-api.localsolutions.theknot.com/identities';
export const singularityPortalApiUrl =
	'https://singularity-portal-api.guestservices.theknot.com/generate/text';
export const internalCreateImageReviewsUrl =
	'/marketplace/reviews/images/create';
export const internalDeleteImageReviewsUrl =
	'/marketplace/reviews/images/delete';
export const internalGenerateVrmMessageUrl = '/marketplace/rfq/vrm/generate';
export const internalPvRecRecommendationsUrl =
	'/marketplace/recommendations/pvrec';
export const internalCompassLocationUrl = '/marketplace/location/search';

export const gtmId = 'GTM-KBVGRZX';
export const datadomeUtilsUrl =
	'https://union.theknot.com/dist/v2/compliance-theknot/latest/bundles/datadome-utils.init.js';
export const gaTrackingId = 'UA-776588-1';

export const tkProUrl = 'https://partnerssignup.theknot.com';
export const vendorManagerUrl = 'https://theknot.com/wedding-vendor-manager';

export const conversationsApi = `${noServicesUrl}/local-partners/api/conversation-theknot/conversations`;
export const conversationsApiK8 =
	'http://service-conversation-theknot-api.localvendorstech/conversations';
export const conversationsAuthApi = `${noServicesUrl}/local-partners/api/app-auth/auth/member`;
export const conversationsAuthApiK8 = 'http://service-app-auth/auth/member';
export const transactionsAPIUrl = `${noServicesUrl}/local-partners/api/transactions`;
export const bulkInquireAPIUrl = `${noServicesUrl}/local-partners/api/conversation-theknot/conversations/bulkInquire`;
export const inquireAPIUrl = `${noServicesUrl}/local-partners/api/conversation-theknot/conversations/inquire`;
export const inboxUrl = `${tkHost}/inbox/conversations`;

/* gtm experiments */
export const hideFeaturedExperimentId = 'sh9nlHrLSyWTpZbNifXLSA';

const unknownId = 'UNKNOWN_PROD_ID';
/** @type Experiments.Settings */
export const experiments = {
	recentlyViewed: '399ea62a-3eef-4df5-aee0-a58db4af6218',
	userEngagementInteractivity: '66d249d5-fed4-4d82-9014-a667da759f90',
	mobileMapViewV2: '187a8a70-7912-4447-ac23-4873e3bae7eb',
	vendorCardsRecommendations: '00012a2a-1241-4773-9376-a979683a767b',
	storefrontsNetwork: '6ad39529-3c31-4b97-a6bb-87efd90e9ee4',
	highlightHeaderIcons: '6c69682c-8628-4999-ab19-1d77c65047a9',
	reviewFlowExitModalV2: '7c3ee9bb-9547-4842-8631-a49806b83bd5',
	newLoginWhenFavoritingV2: '548787f1-3363-4433-ae88-3d236561993a',
	vrmMessageOptimizer: 'bd290610-f557-44d2-822e-33c6d66c2d3a',
	vendorCardUiUpdates: 'afd1f345-2c0e-4b04-b2b2-a89fff888f2c',
	anonymousVmInbox: '80439d38-d0e2-4d13-904d-653a2ca6f282',
	rfqHidePrivateRelayEmail: '433bb1a7-f7e2-49fa-abfb-628063f6ebd2',
	storefrontCompletionPenalty: '3e9ab13e-b170-492c-a682-af3f5962b7de',
	reviewFormProgressBar: '777de4be-f649-483c-ac09-b47b819c0555',
	pomDirectoryPageFilters: 'bbd52dba-468b-4d5b-b12e-8cbaf202a70d',
	reviewPhotoFilterV2: '99329bd5-dc1e-416b-8c1c-4bcbc10074b3',
	storefrontPeaceOfMind: '442e2160-c480-4175-8fe0-975db8ad2f2f',
	storefrontPeaceOfMindRetest: '259b4a6a-e130-4abf-bde4-ab61f1490346',
	streamlined: '5c55703c-1f1a-4071-9bd2-8a5d4c342cfe',
	reviewsLayoutAlignment: 'b3c2449d-481b-4863-85e0-ffcfdb7fc4f7',
	newCTA: 'eeba9ad8-be11-403e-9634-70925b028f41',
	newCopy: 'b3057df0-28f1-4617-b7a8-d0259ecfcbc9',
	compassModelLocation: 'a7f9c611-ec3e-42be-a1db-c768a59e9563',
	crossCategoryLink: 'fa215d4b-b4e4-4812-baf6-b43190121de7',
	mcVrmPostBookingStorefront: '426b36c2-5d90-4a4b-931f-bf3a70301426',
	sortRelevanceModel: '0644e39c-88d2-4655-b835-f8b34b18ddab',
	storefrontPeaceOfMindRetestPartTwo: '8e8e43c7-953b-400e-87bc-fad19118bf4f',
	bylNonAuthEntrypoints: '5da52650-7609-494e-bfc8-204090c7f29a',
	novaV1: '66fd198e-4c00-42b9-a8f0-20ad9583e1da',
	weddingsHostedCountBadge: '6170eeae-0567-4942-87c2-dc7eb69c67fd',
	filtersPolish: 'd2614643-a51e-45e7-8e0a-816a27840258',
	improveVendorCardScannability: '1b989260-a4f1-4c0b-8144-154d7c0437ef',
	improveMpPerformanceTier2: '934632eb-40f3-4b0e-8863-d95b398307ec',
	improveMpPerformanceTier3: '34912d25-2cae-48f1-958c-556dffb6eef6',
	markAsBookedLiteStorefronts: '4f602b36-3215-46e4-a12c-f56ebe488b33',
	requestQuoteCtaChange: '1caba4aa-dcac-4883-a91f-cc92d79b9972',
	rfqCtaCopyVenues: '6dad5039-3694-4b8d-9b65-3fb80d7a1b43',
	rfqFormHeightOptimization: 'f0750254-9d6b-4dff-b21f-c9b1507ff839',
	lpSearchBar: '7cf632f0-bcf6-4f9c-b64d-e96602bd8e09',
	nonResponsiveVendors: '613602d7-fc0b-4755-b2fc-21a928b11db9',
};

// If your new experiment is a backend experiment add it to this array
// This array of keys will be used to add the assignment when generating a hash key for search results
/** @type {string[]} */
export const backendExperimentKeys = [
	'12e8f8e4-232b-4de7-8701-1b2a16e464aa', // Lite Threshold
	'6c65df7c-43d3-47ec-a552-66a587f1f1fb', // Landings SSS Search
	'3e9ab13e-b170-492c-a682-af3f5962b7de', // SSS Storefront Completion Penalty
	'0644e39c-88d2-4655-b835-f8b34b18ddab', // Sort Relevance Model
	'613602d7-fc0b-4755-b2fc-21a928b11db9', // Non-Responsive Vendors
];

export const awards = {
	bow: {
		beforeStartDate: {
			year: '2025',
			name: '2025 Best of Weddings',
			filterId: '586476df-c2fa-4c98-879d-87297163f8d1',
			filterSubText: 'Top Rated Vendors of the Year',
			slug: 'current-winner',
			iconId: '9f56c034-2057-4a02-99ee-18cc8c516ba7',
		},
		afterStartDate: {
			year: '2026',
			name: '2026 Best of Weddings',
			filterId: 'd98faf54-cb69-451c-b8be-5f2a5a6dea19',
			filterSubText: 'Top Rated Vendors of the Year',
			slug: 'current-winner',
			iconId: 'a8d5af98-7fba-4287-a568-695c3d6436e1',
		},
	},
	hof: {
		beforeStartDate: {
			year: '2025',
			name: 'Hall of Fame',
			filterId: '19f33d4a-0a5a-48e2-af70-39f94ea4ea7f',
			filterSubText: 'Won Best of Weddings 4+ times',
			slug: 'hall-of-fame',
			iconId: '6738d190-bb59-4af8-bbe3-df752b1f6f51',
		},
		afterStartDate: {
			year: '2026',
			name: 'Hall of Fame',
			filterId: '19f33d4a-0a5a-48e2-af70-39f94ea4ea7f',
			filterSubText: 'Won Best of Weddings 4+ times',
			slug: 'hall-of-fame',
			iconId: '6738d190-bb59-4af8-bbe3-df752b1f6f51',
		},
	},
	endDate: 'January 21, 2027 00:00:00 EST',
	startDate: 'January 21, 2026 03:00:00 EST',
};

/* base API URL */
export const xoAPIRootUrl = 'https://no-services.theknot.com';
export const marketplaceGraphqlUrl =
	'https://prod-marketplace-api.localsolutions.theknot.com/graphql';

/* hosts */
export const bluecardRootUrl = 'https://prod.bluecard.theknot.com';

/* endpoints */
export const bluecardWeddingVisionExistsUrl = `${bluecardRootUrl}/api/v1/users/`;
export const bulkInquiryUrl = `${xoAPIRootUrl}/local-partners/api/conversation-theknot/conversations/bulkInquire`;

const BOW_CURRENT_WINNER_ID = withinDateRange({
	startDate: awards.startDate,
})
	? awards.bow.afterStartDate.filterId
	: awards.bow.beforeStartDate.filterId;

export const SearchConstants = {
	DEFAULT_LIMIT: 30,
	BOW_CURRENT_WINNER_ID,
	BOW_HALL_OF_FAME_ID: awards.hof.beforeStartDate.filterId,
	BOW_FILTER_SLUG: 'best-of-weddings',
	BOW_MEDAL_MEDIA_ID: 'b87d3db7-35c3-4a97-87db-1059c238c37d',
	INTERNAL_REFERRER_SORT: 'featured',
};

export const adSlotEnv = 'production';

export const gpFeatureFlagEndpointUrl = 'https://www.weddingpro.com';

export const gpBaseUrl = 'https://www.weddingwire.com';

export const seoExperimentUrl =
	'https://svc-internal.theknotww.com/seoexperimentationapi';
